import { redirectToLead } from '../lead.popup/redirectToLead';

(function () {
  'use strict';

  angular
    .module('unit.interested.leads')
    .controller('unitInterestedLeadsCtrl', unitInterestedLeadsCtrl);

  unitInterestedLeadsCtrl.$inject = [
    'UnitInterestedLeads',
    '$rootScope',
    '$state',
    '$mdDialog',
    '$location',
    '$window',
    '$cookieStore',
    '$translate',
    '$timeout',
    'moment',
    'telFilter',
    'localStorageService',
  ];

  function unitInterestedLeadsCtrl(
    UnitInterestedLeads,
    $rootScope,
    $state,
    /** @type {angular.material.IDialogService} */ $mdDialog,
    $location,
    $window,
    $cookieStore,
    $translate,
    $timeout,
    moment,
    telFilter,
    localStorageService,
  ) {
    var vm = this;
    var lsLead = null;

    var textNoName = $translate.instant('unit.popup.noname');
    var textHowToAddTitle = $translate.instant(
      'unit.popup.modal.howtoadd.title',
    );
    var textHowToAddMessage = $translate.instant(
      'unit.popup.modal.howtoadd.message',
    );
    var textGotIt = $translate.instant('general.modal.got.it');
    $rootScope.$on('$translateChangeSuccess', function () {
      textNoName = $translate.instant('unit.popup.noname');
      textHowToAddTitle = $translate.instant('unit.popup.modal.howtoadd.title');
      textHowToAddMessage = $translate.instant(
        'unit.popup.modal.howtoadd.message',
      );
      textGotIt = $translate.instant('general.modal.got.it');
    });

    vm.lastLeadTooltip = '';
    vm.leads = [];
    vm.leadExists = false;
    vm.isFetchingIntegration = false;

    UnitInterestedLeads.get({ id: vm.unitId }, function (leads) {
      vm.leads = leads;
      checkIfLeadExists();
    });

    vm.leadStatuses = UnitInterestedLeads.getLeadStatuses();

    initLSLead();

    // Edit lead
    vm.editLead = function (lead) {
      lead.isEdit = true;

      // Хак, чтобы не терялись кастом филды, когда открываем редактирование сразу после создания
      // Почему-то в этот момент они не в виде объекта, а в виде массива объектов. Преобразовываем
      if (Array.isArray(lead.custom_fields)) {
        var proxyCustomFieldsObj = {};
        angular.forEach(lead.custom_fields, function (el, i) {
          proxyCustomFieldsObj[el.field_id] = el.value;
        });
        lead.custom_fields = proxyCustomFieldsObj;
      }
    };

    vm.saveEditLead = function (lead) {
      UnitInterestedLeads.update({ id: lead.id }, lead, function (response) {
        lead.isEdit = false;
      });
    };

    vm.cancelEditLead = function (lead) {
      lead.isEdit = false;
    };

    vm.saveNewLead = function (lead) {
      lead.action_type = 3;
      lead.unit_id = vm.unitId;
      lead.lead_id = lead.id;

      UnitInterestedLeads.create(lead, function (response) {
        vm.leads.push(response);
      });
    };

    vm.redirectToLead = function (leadId) {
      redirectToLead({
        leadId,
        $location,
        $state,
      });

      return false;
    };

    vm.showModalHowToAdd = function () {
      $mdDialog.show(
        $mdDialog
          .alert()
          .clickOutsideToClose(true)
          .title(textHowToAddTitle)
          .textContent(textHowToAddMessage)
          .ariaLabel('Alert Dialog')
          .ok(textGotIt),
      );
    };

    /*$rootScope.$on('lock.unit.deal.lead', function(event, state) {
            vm.lock_add = state;
        });*/

    vm.hasLink = function (str) {
      //estContactsChecker.hasLink(str);
      if (
        /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/.test(
          str,
        )
      )
        return true;
      else return false;
    };

    vm.hasEmail = function (str) {
      //estContactsChecker.hasEmail(str);
      if (
        /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i.test(
          str,
        )
      )
        return true;
      else return false;
    };

    function initLSLead() {
      if (localStorageService.get('lead')) {
        lsLead = localStorageService.get('lead');
      }

      if (lsLead) {
        var lastLeadTooltip = '';

        if (typeof lsLead.name !== 'undefined') {
          lastLeadTooltip = lsLead.name;
        } else {
          lastLeadTooltip = textNoName;
        }
        if (typeof lsLead.phone !== 'undefined' && lsLead.phone !== null) {
          lastLeadTooltip += ' +' + telFilter(lsLead.phone);
        }
        if (typeof lsLead.email !== 'undefined' && lsLead.email !== null) {
          lastLeadTooltip += ' ' + lsLead.email;
        }
        vm.lastLeadTooltip = lastLeadTooltip.trim();
      }
    }

    vm.fillWithLastLeadData = function () {
      vm.saveNewLead(lsLead);
      vm.leadExists = true;
    };

    vm.refreshDataFromIntegration = function (leads) {
      vm.isFetchingIntegration = true;
      //make request
      //show loading state
      //update array
      //cancel loading state
      $timeout(function () {
        vm.isFetchingIntegration = false;
      }, 1500);
    };

    function checkIfLeadExists() {
      if (vm.leads.length > 0 && lsLead) {
        vm.leads.forEach(function (lead) {
          if (lead.id == lsLead.id) {
            vm.leadExists = true;
          }
        });
      }
    }
  }
})();
